import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../../../infrastructure/redux/store';
import { alternarDia, limparSelecao } from '../../../reducers/alocacao.reducer';
import { Container, Dia } from './styles';

interface IDia {
  nome: string;
  value: string;
  status: boolean;
  cor: string;
}

const Dias: React.FC = () => {
  const { theme } = useSelector((state: RootState) => state.theme);

  const [dias, setDias] = useState<IDia[]>([]);

  const dispatch = useDispatch();

  const selecionar_dia = (index: number) => {
    const dia = {
      ...dias[index],
      status: !dias[index].status,
    };

    dispatch(limparSelecao('alocar'));
    dispatch(alternarDia(dia.value));
    setDias([...dias.slice(0, index), dia, ...dias.slice(index + 1)]);
  };

  useEffect(() => {
    setDias([
      { nome: 'dom', value: 'DOM', status: true, cor: theme.colors.primary },
      { nome: 'seg', value: 'SEG', status: true, cor: theme.colors.primary },
      { nome: 'ter', value: 'TER', status: true, cor: theme.colors.primary },
      { nome: 'qua', value: 'QUA', status: true, cor: theme.colors.primary },
      { nome: 'qui', value: 'QUI', status: true, cor: theme.colors.primary },
      { nome: 'sex', value: 'SEX', status: true, cor: theme.colors.primary },
      { nome: 'sab', value: 'SÁB', status: true, cor: theme.colors.primary },
      { nome: 'fer', value: 'FERIADO', status: true, cor: theme.colors.error },
      { nome: 'aloc', value: 'ALOCADO', status: true, cor: theme.colors.info },
    ]);
  }, [theme]);

  return (
    <Container>
      {dias.map((dia, index) => (
        <Dia
          key={dia.nome}
          selected={dia.status}
          onClick={() => selecionar_dia(index)}
          cor={dia.cor}
        >
          {dia.nome}
        </Dia>
      ))}
    </Container>
  );
};

export { Dias };
